/* eslint-disable prettier/prettier */
import { Icon } from "@/components"
import { useStyles } from "@/components/SearchifySelector/SearchifySelector.styles"
import { advancedSearchify } from "app/static/frontend/search-new/searchify/searchify-action-creators"
import React from "react"
import { connect } from "react-redux"
import { getFLVFromQDT } from "app/static/frontend/search-new/routes"

type QuorumDataType = typeof DjangIO.app.models.QuorumDataType
type K = keyof QuorumDataType

interface SearchifySelectorProps {
    button?: {
        title?: string | React.ReactNode
        icon?: string
        className?: string
        style?: object
        dataPlumId?: string
    }
    buttonRef?: React.RefObject<HTMLButtonElement>
    dataType: QuorumDataType[K]
    disabled?: boolean
    maxSearchifySelections?: number
    onChange: (data: object) => void
    openSearchify?: (object) => void
    searchifyHeaderName: string
    searchifyInitialFilters?: object
    style?: object
    submitSearchifyFunc?: object
}

const openSearchify =
    ({ dataType, onChange, searchifyHeaderName, ...rest }) =>
    (dispatch) => {
        dispatch(
            advancedSearchify({
                searchifyFLV: getFLVFromQDT(dataType.value),
                searchifyQDT: dataType,
                shouldOpenSearchifyModal: true,
                maxSearchifySelections: Infinity,
                searchifyHeaderName,
                callBack: onChange,
                ...rest,
            }),
        )
    }

const DisconnectedSearchifySelector = ({
    openSearchify,
    dataType,
    searchifyHeaderName,
    ...props
}: SearchifySelectorProps) => {
    const { classes, cx } = useStyles()
    return (
        <button
            className={cx(classes.button, props.button.className)}
            style={props?.style}
            onClick={() =>
                openSearchify({
                    dataType,
                    onChange: props.onChange,
                    searchifyHeaderName,
                    ...props,
                })
            }
            type="button"
            ref={props.buttonRef}
            disabled={props.disabled}
            data-plum-id={props.button?.dataPlumId || undefined}
        >
            <Icon icon={props.button?.icon || "plus"} iconFamily="far" style={props?.button?.style} />
            {props?.button?.title || "Add Contacts"}
        </button>
    )
}

export const SearchifySelector = connect(null, { openSearchify })(
    DisconnectedSearchifySelector,
) as React.FC<SearchifySelectorProps>
